import NewStepper from '@/app/components/NewStepper/NewStepper';
import { PAGE_LOAD } from '@/constants/dataLayer';

import pushDataLayer from '@/utils/dataLayer';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { trackingSelector } from '@/reducers/tracking/tracking.slice';
import { getTrackingInfo } from '@/utils/tracking';
import useRecaptchaV3 from '@/hooks/useRecaptchaV3';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import styles from './trackingInfo.module.scss';
import './trackingInfo.i18n';

function getHomeUrl(token: string) {
  const url = new URL(document.location.href);
  if (token) url.searchParams.append('token', token);

  return `/${url.search}`;
}

const TrackingInfo: React.FC = () => {
  const [t] = useTranslation();
  const { trackingInfo, pickitCode, token } = useSelector(trackingSelector);
  useRecaptchaV3();

  useEffect(() => {
    pushDataLayer(PAGE_LOAD);
    if (!trackingInfo.pickitNumber) getTrackingInfo(pickitCode, token, true);
  }, [pickitCode, token, trackingInfo.pickitNumber]);

  getHomeUrl(token);
  if (!pickitCode) return <Redirect to={getHomeUrl(token)} />;

  return (
    trackingInfo.pickitNumber && (
      <div className={styles.trackingInfo}>
        <div className={styles.title}>
          <h1>{trackingInfo?.title}</h1>
          <p className={styles.trackingCode}>
            {t('TrackingInfo:subtitle')}
            <span>{trackingInfo?.pickitNumber}</span>
          </p>
        </div>
        <div className={styles.trackingDesktop}>
          <div className={styles.trackingContainer}>
            <NewStepper
              transaction={trackingInfo?.transaction}
              trackingNumber={trackingInfo?.trackingNumber}
              steps={trackingInfo?.tracking}
            />
          </div>
        </div>

        <a className={styles.button} href={getHomeUrl(token)}>
          {t('TrackingInfo:buttonLabel')}
        </a>
      </div>
    )
  );
};

export default TrackingInfo;
